import { useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import {
  Fieldset,
  FormTitle,
  DatePickerField,
  Text,
  SelectField,
  SwitchField,
} from "ui-components/Form";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { countryOptions } from "layouts/views/common/options";

function Receiving({
  headerRender,
  vendorOptions = [],
  vDONoOptions = [],
  setValue,
  customerCode,
  control,
  errors,
  mode = "ADD",
}) {
  const [whOptions, setWhOptions] = useState([]);
  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => {
      const warehouses = data.data.data;
      if (warehouses.length > 0) setValue("warehouseCode", warehouses[0]);
      setWhOptions(warehouses);
    },
  });
  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6 / 2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
      ...(mode === "EDIT" && data.name==="vDONo" && { disabled: true, type: "text" }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "vendorCode":
            options = vendorOptions;
            // onChange = (e, option) => {
            //   setValue("vendorCode", option.value);
            //   setValue("sellerCompany", option.vendShortName);
            // };
            break;
          case "sellerCountry":
            options=countryOptions
            break
          case "warehouseCode":
            options = whOptions;
            break;
          case "vDONo":
            options = vDONoOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
      case "switch":
        renderField = <SwitchField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit MISC Receiving" : "Add MISC Receiving"} />
      <MDBox mt={1.625}>
        {headerRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default Receiving;
